<template>
  <div class="property_view">
    <b-card v-if="dset_type != 'total'" :title="dset_type">
      <b-table-lite
        hover
        :items="prop_groups"
        :fields="fields"
        caption-top
        outlined
      >
        <template #cell(group_properties)="proprow">
          <b-button size="sm" @click="proprow.toggleDetails" class="mr-2">
            {{ proprow.detailsShowing ? "Hide" : "Show" }} Details
          </b-button>
        </template>
        <template #row-details="proprow">
          <b-table-lite
            v-if="search_button"
            hover
            small
            caption-top
            responsive
            :items="proprow.item.group_properties"
            :fields="subfields"
          >
            <template #cell(fetch_citations)="doifetch">
              <b-button
                size="sm"
                @click="pullDois(proprow.item.group_name, doifetch.item)"
                class="mr-2"
              >
                Fetch
              </b-button>
            </template>
          </b-table-lite>
          <b-table-lite
            v-else
            hover
            small
            caption-top
            responsive
            :items="proprow.item.group_properties"
            :fields="subfields_nosearch"
          >
          </b-table-lite>
        </template>
      </b-table-lite>
    </b-card>
    <b-modal
      id="dois_modal"
      ref="fetch_dois_modal"
      :title="`${modal_group}/\n${modal_prop}`"
    >
      <h5>
        Citations: {{ totalRows }} / {{ dset_type }} data sets:
        {{ modal_dsets }}
      </h5>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination>

      <b-table
        hover
        small
        caption-top
        responsive
        :items="modal_dois"
        :fields="doi_fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template #cell(citation_link)="row">
          <b-link
            :href="`/ThermoML/${row.item.citation_link}.html`"
            target="_blank"
          >
            {{ row.item.citation_link }}
          </b-link>
        </template>
      </b-table>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="info"
        @dismissed="dismissCountDown = 0"
      >
        {{ totalRows }} DOIs copied to clipboard
      </b-alert>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            type="button"
            variant="danger"
            size="sm"
            class="float-left"
            v-clipboard:copy="
              modal_dois.map((doi_count) => doi_count.citation_link).join('\n')
            "
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            >Copy DOIs to clipboard
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('dois_modal')"
          >
            Close
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "TMLProp",
  props: {
    dset_type: String,
    group_property: Object,
    search_string: String,
    search_button: Boolean,
  },
  data() {
    return {
      dismissCountDown: 0,
      currentPage: 1,
      totalRows: 0,
      perPage: 20,
      fields: [
        { key: "group_name", variant: "secondary", isRowHeader: true },
        { key: "data_sets" },
        { key: "data_points" },
        { key: "group_properties" },
      ],
      doi_fields: [
        { key: 0, label: "Citation Links" },
        { key: 1, label: "Data Sets" },
      ],
      subfields: [
        { key: "property_name", variant: "dark", isRowHeader: true },
        { key: "data_sets" },
        { key: "data_points" },
        { key: "fetch_citations", label: "Citation Links" },
      ],
      subfields_nosearch: [
        { key: "property_name", variant: "dark", isRowHeader: true },
        { key: "data_sets" },
        { key: "data_points" },
      ],
      modal_prop: "",
      modal_group: "",
      modal_dois: [],
      modal_dsets: 0,
    };
  },
  computed: {
    // convert object of object to the array of objected need for the table
    prop_groups: function () {
      let prop_groups = Object.keys(this.group_property)
        .map((group) => {
          return {
            group_name: group,
            data_points: this.group_property[group].data_points,
            data_sets: this.group_property[group].data_sets,
            group_properties: Object.keys(this.group_property[group])
              .filter((prop) => prop != "data_points")
              .filter((prop) => prop != "data_sets")
              .map((property) => {
                return {
                  property_name: property,
                  data_points: this.group_property[group][property].data_points,
                  data_sets: this.group_property[group][property].data_sets,
                  dois: this.group_property[group][property].dois,
                };
              }),
          };
        })
        .filter(
          (group) =>
            group.group_name != "data_points" && group.group_name != "data_sets"
        );
      return prop_groups;
    },
  },
  methods: {
    pullDois(group_name, prop) {
      let vm = this;
      vm.modal_prop = prop.property_name;
      vm.modal_dsets = prop.data_sets;
      vm.modal_group = group_name;
      let doi_dset = Object.entries(prop.dois)
        .sort(function (a, b) {
          return b[1] - a[1];
        })
        .map((entry) => {
          return {
            citation_link: entry[0],
            data_sets: entry[1],
          };
        });

      vm.modal_dois = doi_dset;
      vm.totalRows = doi_dset.length;
      vm.$refs["fetch_dois_modal"].show();
    },
    onCopy: function (e) {
      this.dismissCountDown = 2;
    },
    onError: function (e) {
      alert("Failed to copy dois");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 !important;
}
</style>
